export default "__VITE_ASSET__e95ed281__"